import { connect } from 'react-redux';
import { compose } from 'redux';
import { Dispatch } from 'redux-api-middleware';
import { addApplication } from 'store/api/applications/application/applicationActions';
import { fetchApplications } from 'store/api/applications/applicationsActions';
import { submitForm } from 'store/api/submitForm/submitForm';
import { AddApplicationPayload, AddApplicationResponse, ApplicationsResponse, ApplicationType } from 'store/api/types';

import { Applications } from './Applications';

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onAddApplication: (uuid: string) =>
    submitForm<AddApplicationResponse>(dispatch, (values: AddApplicationPayload) =>
      addApplication(uuid, ApplicationType.PSD2, values),
    ),
  onFetchApplications: (uuid: string) =>
    dispatch<Promise<ApplicationsResponse>>(fetchApplications(uuid, ApplicationType.PSD2)),
});

export const ApplicationsContainer = compose(
  connect(
    undefined,
    mapDispatchToProps,
  ),
)(Applications);
